import React, { useState, useEffect } from "react";
// import { DataTable } from "primereact/datatable";
// import Loading from "../../components/Loading";
import Loading from "../components/Loading.jsx";
import DataTable from "react-data-table-component";
import { FaEdit, FaTrash, FaEye, FaCalendarAlt, FaBars, FaBorderAll } from "react-icons/fa";
// import { useUserContext } from '../context/DealerProfile.jsx'
import { TfiMenuAlt } from "react-icons/tfi";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../context/DealerProfile.jsx";
import { Link } from "react-router-dom";
import useSWR from "swr";
// import { Pagination } from "flowbite-react";
// Paste this once in your component file or extract to its own file

const SimplePagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }

    return (
        <div className="flex flex-wrap justify-center items-center gap-2 mt-4">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Previous
            </button>



            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Next
            </button>
        </div>
    );
};





export default function LeadsTable() {
    const { dealerDetail, error } = useUserContext();
    // const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    // const [leads, setLeads] = useState([]);
    // const [createdDate, setCreatedDate] = React.useState("");
    const [currentPage, setCurrentPage] = useState(1);
    // const [rowsPerPage, setRowsPerPage] = useState(10);
    const [openDropdown, setOpenDropdown] = useState(null);  // Track open dropdown
    const [formData, setFormData] = useState({}); // Store lead form data
    const [editingId, setEditingId] = useState(null);
    const [tasks, setTasks] = useState([]);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const [searchValues, setSearchValues] = useState({
        page: 1,
        limit: 10,
        dealerEmail: dealerDetail?.Email || "",
    });

    // Open modal
    // Open modal and save current state before changes
    const openModal = () => {
        setPrevSelectedColumns(selectedColumns); // Save current state before changes
        setIsModalOpen(true);
    };

    const wrapCellStyle = {
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "break-word", // extra safeguard
        lineHeight: "1.4",
    };

    const columns = [
        {
            name: "Subject",
            selector: row => row.Subject ?? "",
            cell: row => (
                <span
                    style={{
                        ...wrapCellStyle,
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => navigate(`/task-details/${row.id}`)}
                >
                    {row.Subject}
                </span>
            ),
            sortable: true,
            style: {
                ...wrapCellStyle,
                fontSize: 16,
                color: "#5A5A5C",
            },
            minWidth: "150px", // lets it shrink on smaller screens
        },
        {
            name: "Follow Up Date Time",
            selector: row => {
                const date = new Date(row.Due_Date_Time);
                return isNaN(date) ? 0 : date.getTime();
            },
            cell: row => {
                const date = new Date(row.Due_Date_Time);
                return (
                    <span style={{ ...wrapCellStyle, fontSize: 16, color: "#5A5A5C" }}>
                        {isNaN(date)
                            ? ""
                            : date.toLocaleString("en-IN", {
                                timeZone: "Asia/Kolkata",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            })}
                    </span>
                );
            },
            sortable: true,
            style: {
                ...wrapCellStyle,
                fontSize: 16,
                color: "#5A5A5C",
            },
            minWidth: "120px",
        },
        {
            name: "Status",
            selector: row => row.Status ?? "",
            sortable: true,
            style: { ...wrapCellStyle, fontSize: 16, color: "#5A5A5C" },
        },
        {
            name: "Priority",
            selector: row => row.Priority ?? "",
            sortable: true,
            style: { ...wrapCellStyle, fontSize: 16, color: "#5A5A5C" },
        },
    ];






    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.name)); // Default: Show all columns
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedColumns, setSelectedColumns] = useState([]);


    // State to track the most recently clicked column
    const [lastClickedColumn, setLastClickedColumn] = useState(null);
    const [initialColumns, setInitialColumns] = useState([]); // Track initial columns state


    // Fetch columns from localStorage or default columns when component mounts
    useEffect(() => {
        const storedColumns = localStorage.getItem("selectedColumns");

        if (storedColumns) {
            // If columns are found in localStorage, use them
            const parsedColumns = JSON.parse(storedColumns);
            setSelectedColumns(parsedColumns);
            setInitialColumns(parsedColumns); // Save the initial state
        } else {
            // Otherwise, use default columns (this is assuming 'columns' is your default set)
            const defaultColumns = columns.map(col => col.name);
            setSelectedColumns(defaultColumns);
            setInitialColumns(defaultColumns); // Save the initial state
        }
    }, []);

    // Function to handle column changes
    const handleColumnChange = (colName) => {
        setSelectedColumns((prev) => {
            const updatedColumns = prev.includes(colName)
                ? prev.filter((name) => name !== colName)
                : [...prev, colName];

            try {
                // Ensure only primitive values (strings) are stored
                const safeColumns = updatedColumns.map(col => String(col));
                localStorage.setItem("selectedColumns", JSON.stringify(safeColumns));
            } catch (error) {
                // console.error("Error saving to localStorage:", error);
            }

            // Track the most recent checkbox clicked
            setLastClickedColumn(colName);

            return updatedColumns;
        });
    };


    // Function to apply filters (save to localStorage)
    const applyFilter = () => {
        try {
            // Ensure only primitive values (strings) are stored
            const safeColumns = selectedColumns.map(col => String(col));
            localStorage.setItem("selectedColumns", JSON.stringify(safeColumns));
        } catch (error) {
            // console.error("Error saving to localStorage:", error);
        }

        setIsModalOpen(false);
    };

    const [prevSelectedColumns, setPrevSelectedColumns] = useState([]); // Store previous state



    // Function to reset filter by restoring the saved state
    const resetFilter = () => {
        setSelectedColumns(prevSelectedColumns); // Restore previous selection
        setIsModalOpen(false);
    };


    const filteredColumns = columns.filter(
        col => selectedColumns.includes(col.name) || typeof col.name === "object"
    );







    const [isFetched, setIsFetched] = useState(false);

    //  useEffect(() => {
    //   const fetchLeadValues = async () => {
    //     setIsLoading(true); // Start loading
    //     try {
    //       const response = await fetch("/server/dealer_backend/getAllCalls", {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify({
    //           dealerEmail: dealerDetail?.Email,
    //         }),
    //       });

    //       const data = await response.json();

    //       if (data.status === "success") {
    //         // Filter leads matching dealer email
    //         const filteredLeads = data.data.filter(
    //           (item) => item.Catalyst_User_Email === dealerDetail?.Email
    //         );

    //         // Sort filtered leads by call date descending (latest first)
    //         const sortedLeads = filteredLeads.sort((a, b) => {
    //           const dateA = new Date(a.Created_Time || a.Created_Time || 0);
    //           const dateB = new Date(b.Created_Time || b.Created_Time || 0);
    //           return dateB - dateA; // latest first
    //         });

    //         setLeads(sortedLeads);
    //       } else {
    //         console.error("Failed to fetch calls:", data.error);
    //         setLeads([]); // Reset leads on error
    //       }
    //     } catch (error) {
    //       console.error("Error fetching calls:", error);
    //       setLeads([]);
    //     } finally {
    //       setIsLoading(false);
    //       setIsFetched(true);
    //     }
    //   };

    //   fetchLeadValues();
    // }, []);

    // 1️⃣ State for storing the due date filter (persisted in localStorage)
    const [dueDateTask, setDueDateTask] = useState(() => {
        return localStorage.getItem("dueDateTask") || "";
    });

    useEffect(() => {
        localStorage.setItem("dueDateTask", dueDateTask);
    }, [dueDateTask]);

    // 2️⃣ SWR fetcher remains same


    const fetcher = async (url, params) => {
        const res = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
    };


    const { page, limit } = searchValues;
    const dealerEmail = dealerDetail?.Email;

    // ✅ Build unique cache key (includes pagination + due date filter)
    const key = dealerEmail
        ? [
            "/server/dealer_backend/getAllTasks",
            {
                page,
                limit,
                dealerEmail,
                 listName : dealerDetail?.List_Name,
                ...(dueDateTask ? { dueDate: dueDateTask } : {}) // send filter only if applied
            }
        ]
        : null;

    // ✅ Use SWR with pagination + filter
    const { data, isLoading } = useSWR(
        key,
        ([url, body]) => fetcher(url, body),
        {
            revalidateOnFocus: false,
            keepPreviousData: true,
        }
    );

    // ✅ Sort tasks (backend already paginates + filters, so only light sort here)
    // pull pagination from API response
    const leads = (data?.status === "success" ? data.data : [])?.sort((a, b) => {
        if (dueDateTask) {
            return new Date(b.Due_Date_Time || 0) - new Date(a.Due_Date_Time || 0);
        }
        return new Date(b.Created_Time || 0) - new Date(a.Created_Time || 0);
    });

    const pagination = data?.pagination || { page: 1, limit: 10, totalRecords: 0, totalPages: 1 };
    const totalPages = pagination.totalPages;
    const totalRecords = pagination.totalRecords;






    // const totalPages = Math.ceil(leads.length / rowsPerPage);
    const onPageChange = (newPage) => {
        setCurrentPage(newPage);
        setSearchValues((prev) => ({
            ...prev,
            page: newPage
        }));
    };
    // const handleRowsPerPageChange = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setCurrentPage(1);
    // };


















    function useIsMobile(breakpoint = 768) {
        const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

        useEffect(() => {
            const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, [breakpoint]);

        return isMobile;
    }



    function MobileDonorCard({ donor }) {
        return (
            <Link to={`/task-details/${donor.id}`}>
                <div className="bg-white shadow-md ml-[-43px] rounded-xl p-4 mb-4 w-[120%] hover:bg-gray-50 transition cursor-pointer">
                    <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-lg">
                                {`${donor.Subject ?? ''}`.trim().charAt(0) || ''}

                            </div>
                            <div>
                                <p className="font-semibold text-gray-900">{`${donor.Subject || ''}`.trim()}</p>
                                {/* <p className="text-xs text-gray-500">{donor.id}</p> */}
                            </div>
                        </div>
                        <span className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-full font-semibold ">
                            {new Date(donor.Due_Date_Time).toLocaleString('en-IN', {
                                timeZone: 'Asia/Kolkata',
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                            })}

                        </span>
                    </div>

                    <hr className="my-2" />

                    <div className="text-sm text-gray-700">
                        <div className="flex justify-between mb-1">
                            <span className="text-gray-500">Priority</span>
                            <span>{donor.Priority || 'N/A'}</span>
                        </div>

                        <div className="flex justify-between">
                            <span className="text-gray-500">Status</span>
                            <span>{donor.Status || 'N/A'}</span>
                        </div>



                    </div>
                </div>
            </Link>
        );
    }




    const isMobile = useIsMobile();

    const rowsPerPage = searchValues.limit;

    // ✅ Initialize from localStorage on first render
    useEffect(() => {
        const savedLimit = Number(localStorage.getItem("rowsPerPageTasks")) || 10;
        const savedPage = Number(localStorage.getItem("currentPageTasks")) || 1;

        setSearchValues((prev) => ({
            ...prev,
            limit: savedLimit,
        }));

        setCurrentPage(savedPage);
    }, [setSearchValues]);

    // ✅ Handle rows per page change
    const handleChange = (e) => {
        const value = Number(e.target.value);

        setSearchValues((prev) => ({
            ...prev,
            limit: value,
        }));

        setCurrentPage(1); // reset page
        localStorage.setItem("rowsPerPageTasks", value);
        localStorage.setItem("currentPageTasks", 1);
    };

    // ✅ Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        localStorage.setItem("currentPageTasks", newPage);
    };






    return (
        <div className="p-6 space-y-6 text-gray-800">

            {/* Manage Columns Modal */}
            {isModalOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
                    onClick={() => setIsModalOpen(false)}
                    aria-modal="true"
                    role="dialog"
                    aria-labelledby="manage-columns-title"
                >
                    <div
                        className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 id="manage-columns-title" className="text-xl font-bold mb-5">
                            Manage Columns
                        </h2>

                        {/* Search Input */}
                        <input
                            type="text"
                            placeholder="Search columns..."
                            className="w-full p-2 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            aria-label="Search columns"
                        />

                        {/* Column List with Scroll */}
                        <div className="max-h-60 overflow-auto border border-gray-200 rounded p-3">
                            {columns
                                .filter(col => typeof col.name === "string")
                                .filter(col => col.name.toLowerCase().includes(searchTerm.toLowerCase()))
                                .map((col, index) => {
                                    const isLastName = col.name === "Subject";
                                    return (
                                        <label
                                            key={index}
                                            className={`flex items-center mb-3 cursor-pointer select-none ${isLastName ? "opacity-50 cursor-not-allowed" : "hover:text-blue-600"
                                                }`}
                                        >
                                            <input
                                                type="checkbox"
                                                className="mr-3"
                                                disabled={isLastName}
                                                checked={selectedColumns.includes(col.name)}
                                                onChange={() => !isLastName && handleColumnChange(col.name)}
                                            />
                                            <span>{col.name}</span>
                                        </label>
                                    );
                                })}
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                type="button"
                                onClick={resetFilter}
                                className="px-5 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={applyFilter}
                                className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Table header */}
            <div className="flex justify-between items-center px-2 md:px-6 mb-4">
                {/* Manage Columns Button */}
                {/* <div className="relative group hidden md:inline-flex">
                    <button
                        onClick={openModal}
                        type="button"
                        className="p-2 bg-white shadow rounded-md hover:text-blue-600 transition text-blue-500"
                        aria-label="Manage columns"
                    >
                        <TfiMenuAlt className="text-xl" />
                    </button>
                    <div
                        className="absolute left-1/2 -translate-x-1/2 top-full mt-2 bg-gray-800 text-white text-xs rounded px-2 py-1 shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10"
                        role="tooltip"
                    >
                        Manage Columns
                    </div>
                </div> */}

                <div className="flex items-center justify-between w-full max-w-full flex-wrap gap-2">
                    {/* Left side: Created Time filter */}
                    <div className="flex items-center gap-2 flex-wrap">
                        <label
                            htmlFor="dueDateTask"
                            className="text-gray-700 font-medium select-none whitespace-nowrap text-sm sm:text-base"
                        >
                            Follow Up Date:
                        </label>
                        <input
                            id="dueDateTask"
                            type="date"
                            value={dueDateTask}
                            onChange={(e) => setDueDateTask(e.target.value)}
                            className="border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400 transition shadow-sm text-sm sm:text-base"
                            style={{ minWidth: 0 }}
                        />
                    </div>


                    {/* Right side: Add Task button */}
                    <button
                        onClick={() => navigate("/create-task")}
                        className="create-button bg-[#003967] hover:bg-[#040E18] text-white px-4 py-2 rounded-md transition"
                    >
                        Add Task
                    </button>
                </div>






                {/* Add Lead Button - Uncomment if needed */}


            </div>

            {/* Loading State */}
            {isLoading ? (
                <div className="flex justify-center items-center gap-3 py-10 text-blue-600" role="status" aria-live="polite">
                    <svg
                        className="animate-spin h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        />
                    </svg>
                    Loading Data...
                </div>
            ) : leads.length === 0 ? (
                <div className="text-center py-10 text-blue-600 font-medium">
                    No data available
                </div>
            ) : isMobile ? (
                <div className="px-4 space-y-4">
                    {leads.map((donor, index) => (
                        <MobileDonorCard key={index} donor={donor} />
                    ))}
                </div>
            ) : (
                <>
                    {/* DataTable */}
                    <div className="overflow-auto max-w-full rounded-lg shadow border border-gray-200">
                        <DataTable
                            columns={columns}
                            data={leads}
                            fixedHeader
                            dense
                            responsive
                            highlightOnHover
                            progressPending={isLoading}
                            className="custom-table text-base"
                            onRowClicked={(row) => navigate(`/task-details/${row.id}`)}
                            customStyles={{
                                headCells: { style: { fontSize: "16px", fontWeight: "700", background: "#F3F7FA", color: "#1e3a8a" } },
                                cells: { style: { whiteSpace: "nowrap", overflow: "visible", fontSize: "15px" } },
                                rows: {
                                    style: {
                                        transition: "background 0.2s",
                                        "&:hover": { background: "#ebf4ff" },
                                    },
                                },
                            }}
                            style={FaBorderAll}
                        />
                    </div>

                    {/* Pagination */}
                    <div className="mt-6 flex flex-wrap justify-between items-center gap-6 px-2 ">
                        {/* Entry Count */}
                        <div className="flex items-center text-gray-700 text-sm md:text-base">
                            <span className="font-medium mr-1">Showing</span>
                            <span className="px-2 py-1 bg-blue-100 text-blue-700 font-semibold rounded-lg">
                                {`${(currentPage - 1) * rowsPerPage + 1}–${Math.min(
                                    currentPage * rowsPerPage,
                                    totalRecords
                                )}`}
                            </span>
                            <span className="ml-1">of {totalRecords} entries</span>
                        </div>

                        {/* Records per Page */}
                        <div className="flex items-center gap-2">
                            <label
                                htmlFor="recordsPerPage"
                                className="text-gray-700 font-medium select-none"
                            >
                                Per page:
                            </label>
                            <select
                                id="recordsPerPage"
                                value={searchValues.limit}
                                onChange={(e) =>
                                    setSearchValues((prev) => ({
                                        ...prev,
                                        limit: Number(e.target.value),
                                    }))
                                }

                                className="border border-gray-300 rounded-lg px-3 py-1.5 shadow-sm bg-white 
                 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                            >
                                {[10, 25, 50, 100].map((n) => (
                                    <option key={n} value={n}>
                                        {n}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Pagination */}
                        <SimplePagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(totalRecords / rowsPerPage)}
                            onPageChange={onPageChange}
                        />
                    </div>

                </>
            )}
        </div>
    );

}
